export const buttonStyles = {
  components: {
    // Styling the <Input> Element
    Button: {
      variants: {},
    },
  },
};
